import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import './Message-List.scss';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../shared/custom-dragdrop/dragDrop';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  danger,
  success,
  generateConfirmationMessage,
} from '../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import { notificationManager } from '../../../../utils/NotificationUtils';
import MultipleDeleteConfirmationPopup from '../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import ActivationPopupModel from '../../../../shared/activation-popup/Activation-Popup';
import WarningPopup from '../../../../shared/warning-popup/Warning-Popup';
import DuplicatePopupModel from '../../../../shared/duplicate-popup/Duplicate-Popup';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import {
  deleteSelectedItems,
  deleteWelcomeMessageById,
  getWelcomeMessages,
  toggleWelcomeMessageStatus,
  updateSelectedItemsStatus,
  duplicateWelcomeMessageById,
} from '../../../../utils/ServicesAPIUtils';
import { createDataSortMapping } from '../../../../utils/PropertyAPIUtils';
import {
  WELCOME_MESSAGE_CREATE,
  WELCOME_MESSAGE_VIEW,
} from '../../../../constants/WelcomeMessageConst';

const MESSAGE_FILTER = [
  {
    id: 'device',
    title: 'Device',
    field: 'deviceTypes',
    subMenu: [
      { id: 'TV', name: 'TV', selected: false },
      { id: 'Tablet', name: 'Tablet', selected: false },
    ],
  },
  {
    id: 'status',
    title: 'Status',
    field: 'status',
    subMenu: [
      { id: 'Active', name: 'Active', selected: false },
      { id: 'Inactive', name: 'Inactive', selected: false },
    ],
  },
  {
    id: 'audience',
    title: 'Audience',
    field: 'audienceType',
    subMenu: [
      { id: 'All', name: 'All', selected: false },
      { id: 'Custom', name: 'Custom', selected: false },
    ],
  },
];

const MessageList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    refreshToggle,
  } = props;

  const [messageList, setMessageList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [originalMessageList, setOriginalMessageList] = useState([]);
  const updateOriginalMessages = (newList) => {
    setOriginalMessageList(newList);
    return { type: 'NO_OP' };
  };
  const [searchText, setSearchText] = useState('');
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    activate: false,
    warning: false,
    duplicateStatus: false,
    anchorEl: null,
    group: null,
  });
  const [visible, setVisible] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [filterDataList, setFilterDataList] = useState(MESSAGE_FILTER);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [isActive, setIsActive] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';

  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const isFilterApplied = useRef(false);
  const dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedMessagesLength) {
      setMessageList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(WELCOME_MESSAGE_CREATE, true);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      activate: false,
      warning: false,
      duplicateStatus: false,
      anchorEl: null,
      group: null,
    });
  };

  const onViewDetails = (message, e, isClassDisabled) => {
    if (isClassDisabled) {
      onDrawerToggle(WELCOME_MESSAGE_VIEW, true, message, 'view');
      return;
    }

    if (e?.target?.tagName === 'TD') {
      onDrawerToggle(WELCOME_MESSAGE_VIEW, true, message, 'view');
    }
  };

  const onViewDetailsIcon = (e) => {
    if (
      e.target.className ===
      'MuiButtonBase-root MuiListItem-root MuiMenuItem-root pe-4 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button'
    ) {
      onDrawerToggle(WELCOME_MESSAGE_VIEW, true, selectedValue.group, 'view');
      handleClose();
    }
  };

  const handleCellMenuClick = (event, message) => {
    if (selectedMessagesLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: message.id,
        name: message.title,
        title: '',
        description: '',
        status: false,
        activate: false,
        warning: false,
        duplicateStatus: false,
        isActive: message.isActive,
        anchorEl: event.currentTarget,
        group: message,
      });
    }
  };

  const onEditMessage = (e) => {
    if (selectedValue && selectedValue?.group) {
      onDrawerToggle(WELCOME_MESSAGE_CREATE, true, selectedValue?.group);
      handleClose();
    }
  };

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(messageList, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.title.toLowerCase().includes(searchText.toLowerCase()),
    );
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setMessageList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedMessagesLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText && !isFilterApplied.current) {
      setShowBulkSearchAlert(false);
      setMessageList(originalMessageList.map((item) => ({ ...item, isChecked: false })));
    }
  };

  useEffect(() => {
    updateSelectedModule(messageList, setActionMenuList, setIsAllSelected);
  }, [messageList]);

  const countCheckedItems = (items) => {
    return items?.filter((item) => item?.selected)?.length || 0;
  };

  const deviceFilterCount = countCheckedItems(
    filterDataList.find((filter) => filter.field === 'deviceTypes')?.subMenu,
  );
  const statusFilterCount = countCheckedItems(
    filterDataList.find((filter) => filter.field === 'status')?.subMenu,
  );
  const audienceFilterCount = countCheckedItems(
    filterDataList.find((filter) => filter.field === 'audienceType')?.subMenu,
  );

  const resetFilterDataList = () => {
    setFilterDataList(
      MESSAGE_FILTER.map((filter) =>
        filter.subMenu.length > 0
          ? {
              ...filter,
              subMenu: filter.subMenu.map((subItem) => ({ ...subItem, selected: false })),
            }
          : filter,
      ),
    );
    isFilterApplied.current = false;
  };

  useEffect(() => {
    resetFilterDataList();
    fetchWelcomeMessages();
  }, [selectedHotel, refreshToggle, lang]);

  useEffect(() => {
    if (rowsPerPage !== 10) {
      onsetRowsPerPage(10);
      onsetPage(0);
    }
  }, []);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const fetchWelcomeMessages = async () => {
    setSearchText('');
    setShowBulkSearchAlert(false);
    onsetPage(0);
    setLoading(true);
    try {
      if (!selectedHotel) {
        setMessageList([]);
        setOriginalMessageList([]);
        if (props.setGlobalPlaceHolder) props.setGlobalPlaceHolder([]);
        return;
      }
      dispatch(stepUpLoaderCount());
      const response = await getWelcomeMessages(selectedHotel, lang);
      const messages = response.data.listWelcomeMessage.map((message) => ({
        ...message,
        status: message.isActive ? 'Active' : 'Inactive',
        statusClass: message.isActive ? 'pill-active' : 'pill-inactive theme-dark-green',
        device: message.deviceTypes.join(', '),
        audience: message.audienceType === 'All' ? 'All' : 'Custom',
        isChecked: false,
      }));
      setMessageList(messages);
      setOriginalMessageList(messages);
      setFilteredBaseList(messages);
      if (props.setGlobalPlaceHolder) props.setGlobalPlaceHolder(messages);
    } catch (error) {
      if (error.message && error.message.includes('hotel record not found')) {
        setMessageList([]);
        setOriginalMessageList([]);
        if (props.setGlobalPlaceHolder) props.setGlobalPlaceHolder([]);
      } else {
        if (!(error.message === 'Failed to fetch' || error.name === 'AbortError')) {
          notificationManager(danger, 'Failed to fetch welcome messages');
        }
      }
    } finally {
      setLoading(false);
      dispatch(stepDownLoaderCount());
    }
  };

  const filteredRecords = (filters, field) => {
    setSearchText('');
    setShowBulkSearchAlert(false);
    onsetPage(0);
    if (field === 'all') {
      setFilteredBaseList(originalMessageList);
      setMessageList(originalMessageList);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const activeFilters = {};
      filterDataList.forEach((filter) => {
        const selectedValues = filter.subMenu
          .filter((item) => item.selected)
          .map((item) => item.id);
        if (selectedValues.length > 0) activeFilters[filter.field] = selectedValues;
      });

      const filtered = originalMessageList.filter((message) => {
        for (let [f, values] of Object.entries(activeFilters)) {
          if (f === 'deviceTypes') {
            if (!message.deviceTypes.some((d) => values.includes(d))) return false;
          } else if (!values.includes(message[f])) return false;
        }
        return true;
      });

      onsetPage(0);
      if (isAllSelected || selectedMessagesLength > 0) {
        setShowBulkFilterAlert(true);
      } else {
        setFilteredBaseList(filtered);
        setMessageList(filtered);
      }
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleCheckboxChange = (id) => {
    let actionList = [];
    const idx = messageList.findIndex((m) => m.id === id);
    if (idx !== -1) {
      const updated = [...messageList];
      updated[idx].isChecked = !updated[idx].isChecked;
      setMessageList(updated);
      const selected = updated.filter((m) => m.isChecked);
      if (selected.length) {
        if (selected.some((m) => m.status === 'Active')) actionList.push('Deactivate');
        if (selected.some((m) => m.status === 'Inactive')) actionList.push('Activate');
        setIsAllSelected(updated.every((m) => m.isChecked));
      } else {
        setIsAllSelected(false);
      }
      setActionMenuList(actionList);
    }
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsAllSelected(checked);
    const updated = messageList.map((m) => ({ ...m, isChecked: checked }));
    setMessageList(updated);
    if (checked) {
      const list = [];
      if (updated.some((m) => m.status === 'Inactive')) list.push('Activate');
      if (updated.some((m) => m.status === 'Active')) list.push('Deactivate');
      setActionMenuList(list);
    } else {
      setActionMenuList([]);
    }
  };

  const handleAction = (action) => {
    const sel = messageList.filter((m) => m.isChecked);
    if (action === 'Delete' && sel.length) {
      setShowMultipleDeleteConfirmation(true);
      setActionName('delete');
    }
    if (action === 'Activate' && sel.length) {
      setShowBulkActiveDeactiveConfirmation(true);
      setActionName('activate');
      setIsActive(true);
    }
    if (action === 'Deactivate' && sel.length) {
      setShowBulkActiveDeactiveConfirmation(true);
      setActionName('deactivate');
      setIsActive(false);
    }
  };

  const selectedMessagesLength = messageList.filter((m) => m.isChecked).length;

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setMessageList(originalMessageList.map((m) => ({ ...m, isChecked: false })));
  };

  const handleDeletePopupOpen = () => {
    const curr = { ...selectedValue };
    handleClose();
    curr.title = 'Are you sure you want to delete';
    curr.description = 'This action cannot be reversed.';
    curr.status = true;
    curr.anchorEl = null;
    setSelectedValue(curr);
  };

  const handleDeactivatePopupOpen = () => {
    setSelectedValue((prev) => ({
      ...prev,
      name: `${prev.name}?`,
      title: `Are you sure you want to deactivate `,
      description: 'You can activate this Welcome Message again if needed.',
      status: true,
      anchorEl: null,
      activate: true,
    }));
  };

  const handleActivatePopupOpen = () => {
    setSelectedValue((prev) => ({
      ...prev,
      name: `${prev.name}?`,
      title: `Are you sure you want to activate `,
      description: 'You can deactivate this Welcome Message again if needed.',
      status: true,
      anchorEl: null,
      activate: true,
    }));
  };

  const onDeleteCancel = () => {
    setSelectedValue((prev) => ({
      ...prev,
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      activate: false,
      anchorEl: null,
    }));
  };

  const deleteMessage = async () => {
    setSearchText('');
    setShowBulkSearchAlert(false);
    onsetPage(0);
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';
      await deleteWelcomeMessageById(selectedValue.id, selectedHotel, lang);
      const updated = originalMessageList.filter((m) => m.id !== selectedValue.id);
      setOriginalMessageList(updated);
      setMessageList(updated);
      if (props.setGlobalPlaceHolder) props.setGlobalPlaceHolder(updated);
      notificationManager(success, 'Welcome Message deleted successfully');
      setSelectedValue((prev) => ({ ...prev, id: '' }));
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors?.[0]?.message || 'Failed to delete Welcome Message',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const listOfMessageIds = messageList.filter((m) => m.isChecked).map((m) => m.id);

  const deleteMultipleMessages = async () => {
    setSearchText('');
    setShowBulkSearchAlert(false);
    onsetPage(0);
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied.current;
      const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';
      await deleteSelectedItems(
        listOfMessageIds,
        selectedHotel,
        lang,
        'WELCOME_MESSAGE',
        '',
        filterApplied ? false : isAllSelected,
      );
      await fetchWelcomeMessages();
      notificationManager(success, 'Welcome Messages deleted successfully');
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors?.[0]?.message || 'Failed to delete Welcome Messages',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const handleActiveDeactivate = async () => {
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';
      await toggleWelcomeMessageStatus(selectedValue.id, selectedHotel, lang);
      await fetchWelcomeMessages();
      const actionType = selectedValue.group.status === 'Inactive' ? 'Activated' : 'Deactivated';
      notificationManager(success, `Welcome Message ${actionType} successfully`);
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors?.[0]?.message || 'The status of the Welcome Message was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onApiCallConfirmationMessage = generateConfirmationMessage(
    'Welcome Message',
    listOfMessageIds.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied.current;
      const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';
      await updateSelectedItemsStatus(
        listOfMessageIds,
        selectedHotel,
        lang,
        'WELCOME_MESSAGE',
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      setShowBulkActiveDeactiveConfirmation(false);
      await fetchWelcomeMessages();
      notificationManager(success, onApiCallConfirmationMessage);
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors?.[0]?.message || 'The status of the Welcome Message was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onClickDuplicate = (e) => {
    e.stopPropagation();
    setSelectedValue((prev) => ({
      ...prev,
      duplicateStatus: true,
      anchorEl: null,
      title: 'Are you sure you want to duplicate this message?',
      description: 'Please enter a title for the duplicated message.',
    }));
  };

  const duplicateMessage = async (e, newTitle) => {
    e.stopPropagation();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang') !== 'en' ? decryptLocalStorage('lang') : '';
      await duplicateWelcomeMessageById(selectedValue.id, newTitle, selectedHotel, lang);
      await fetchWelcomeMessages();
      notificationManager(success, 'Message duplicated successfully');
    } catch (err) {
      notificationManager(danger, err.graphQLErrors?.[0]?.message || 'Failed to duplicate message');
    } finally {
      dispatch(stepDownLoaderCount());
      handleClose();
    }
  };

  const dragDisabled = !dragEnabled || messageList?.length <= 1;

  return (
    <div>
      {selectedValue.id && selectedValue.status && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteMessage}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedMessagesLength} ${
            selectedMessagesLength > 1 ? 'welcome messages' : 'welcome message'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={deleteMultipleMessages}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedMessagesLength} ${
            selectedMessagesLength > 1 ? 'welcome messages' : 'welcome message'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={handleMultipleStatusChange}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {selectedValue.id && selectedValue.warning && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn />
      )}
      {selectedValue.duplicateStatus && selectedValue.id && (
        <DuplicatePopupModel
          duplicatePopUp={selectedValue}
          onDuplicate={duplicateMessage}
          onDuplicateCancel={handleClose}
        />
      )}
      <div className='mt-4 mb-4 group-list-container'>
        <SearchBar
          type='CREATE'
          buttonName='Add Message'
          setSearchText={handleSearchText}
          onOpenDrawer={onOpenDrawer}
          filterList={filterDataList}
          setFilterDataList={setFilterDataList}
          filteredRecoard={filteredRecords}
          displayAddOrEdit='show'
          visible={visible}
          setVisible={setVisible}
          popUp={popUp}
          setPopUp={setPopUp}
          placeHolder={messageList}
          setPlaceHolder={setMessageList}
          globalPlaceHolder={originalMessageList}
          dispatch={dispatch}
          displayText='Messages'
          module='WELCOME_MESSAGE'
          searchText={searchText}
          setSearch={setSearchText}
          actionMenuItems={actionMenuList}
          handleAction={handleAction}
          mappingApi={createDataSortMapping}
          deviceFilterCount={deviceFilterCount}
          statusFilterCount={statusFilterCount}
          audienceFilterCount={audienceFilterCount}
          setGlobalPlaceHolder={updateOriginalMessages}
          setDrag={setDragEnabled}
        />
        <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
          {loading ? (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          ) : (
            <TableContainer className='message-list-table'>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected}
                        selectedLength={selectedMessagesLength}
                        totalLength={messageList.length}
                        inputProps={{ 'aria-label': 'select all Messages' }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-25'>Name</TableCell>
                    <TableCell className='w-20'>Device</TableCell>
                    <TableCell className='w-20'>Audience</TableCell>
                    <TableCell className='w-10 ' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='left'></TableCell>
                  </TableRow>
                </TableHead>
                <DragDropContext
                  onDragEnd={(result) =>
                    handleOnDragEnd(
                      result,
                      setVisible,
                      messageList,
                      setMessageList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='messages' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? messageList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : messageList
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(prov) => (
                              <TableRow
                                ref={prov.innerRef}
                                {...prov.draggableProps}
                                {...prov.dragHandleProps}
                                className='border-white pointer'
                                onClick={(e) => onViewDetails(item, e)}
                              >
                                <TableCell className='w-10'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={() => handleCheckboxChange(item?.id)}
                                    checked={item?.isChecked}
                                    inputProps={{
                                      'aria-label': `select message ${item?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-25'>{item?.title}</TableCell>
                                <TableCell className='w-20'>{item?.device}</TableCell>
                                <TableCell className='w-20'>{item?.audience}</TableCell>
                                <TableCell className='w-10'>
                                  <div className='d-flex align-content-center'>
                                    <div
                                      className={
                                        item.statusClass +
                                        ' pill d-flex justify-content-center align-items-center w-35 py-2 px-0'
                                      }
                                    >
                                      <span>{item?.status}</span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  <Button
                                    aria-controls='simple-menu'
                                    aria-haspopup='true'
                                    onClick={(e) => handleCellMenuClick(e, item)}
                                    className='showpopupInner'
                                  >
                                    <MoreHoriz className='showpopupInner' />
                                  </Button>
                                  <Menu
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    {item.status !== 'Completed' &&
                                      (item.status === 'Active' ? (
                                        <MenuItem onClick={handleActiveDeactivate} className='pe-4'>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </MenuItem>
                                      ) : (
                                        <MenuItem onClick={handleActiveDeactivate} className='pe-4'>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </MenuItem>
                                      ))}
                                    <MenuItem onClick={onViewDetailsIcon} className='pe-4'>
                                      <RemoveRedEyeIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    {/*Duplicate Future Feature code*/}
                                    {/* <MenuItem onClick={onClickDuplicate} className='pe-4'>
                                      <ContentCopyIcon className='me-2 action-menu-icon' />
                                      Duplicate
                                    </MenuItem> */}
                                    <MenuItem onClick={handleDeletePopupOpen} className='pe-4'>
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[10, 20, 30, { label: 'All', value: -1 }]}
                      count={messageList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
          {showBulkSearchAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkSearchAlert}
              onClose={handleBulkSearchAlertClose}
              message="If you perform a search after making selections, the items you've selected will be lost."
            />
          )}
          {showBulkKebabSelectionAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkKebabSelectionAlert}
              onClose={() => setShowBulkKebabSelectionAlert(false)}
              message='Please select one item from the list that you want to edit.'
              centerButtonName='OK'
            />
          )}
          {showBulkFilterAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkFilterAlert}
              onClose={() => setShowBulkFilterAlert(false)}
              message="If you perform a filter after making selections, the items you've selected will be lost."
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageList;
